import { useEffect } from "react";
import axios from "axios";

export default function Success() {

  useEffect(() => {

    const alreadySaved =
      sessionStorage.getItem("order_saved");

    if (alreadySaved) {
      return;
    }

    sessionStorage.setItem(
      "order_saved",
      "true"
    );

    const params =
      new URLSearchParams(window.location.search);

    const session_id =
      params.get("session_id");

    axios.post(
      "https://apple2.shopat1stop.com/api/payment-success",
      { session_id }
    );

  }, []);

  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "100px"
      }}
    >
      <h1>🎉 Payment Successful</h1>
      <p>Your order has been placed successfully.</p>
    </div>
  );
}